import { type PropsWithChildren } from 'react';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import Hero from '@jwp/ott-ui-react/src/components/Hero/Hero';
import useBreakpoint, { Breakpoint } from '@jwp/ott-ui-react/src/hooks/useBreakpoint';

import styles from './MediaHero.module.scss';

type Props = PropsWithChildren<{
  image?: string;
  item?: PlaylistItem;
  isPaused?: boolean;
}>;

const MediaHero = ({ image, item, isPaused, children }: Props) => {
//const MediaHero = ({ image, children }: PropsWithChildren<{ image?: string }>) => {
  const breakpoint = useBreakpoint();

  return (
    <header id="video-details">
      <Hero 
      image={image} 
      item={item}
      isPaused={isPaused}
      infoClassName={breakpoint < Breakpoint.md ? styles.infoSmallScreenReorder : undefined}
      >
        {children}
      </Hero>
    </header>
  );
};

export default MediaHero;
